import React from 'react';
import styled from 'styled-components';

import {BITTERSWEET, OzRow, OzCol} from "@ozwol/webui";

const Cnt = styled.div`
  margin-top: 20px;
  // min-height: 30px;
  // padding-top: 40px;
  // margin-top: -30px;
`;
const Text = styled.div`
  color: ${BITTERSWEET};
  background: #FFE2E2;
  padding: 12px 20px;
`;

const ErrorMessage = ({noMargin = false, children}) => {
  if(noMargin){
    return (
      <>
        {children ? 
          <Text>
            {children}
          </Text>
        : null }
      </>  
    )

  }else{
    return (
      <OzRow>
        <OzCol>
          <Cnt>
            {children ? 
              <Text>
                {children}
              </Text>
            : null }
          </Cnt>
        </OzCol>
      </OzRow>
    )

  }
}

export default ErrorMessage;
